var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"markdown markdown-body",style:(_vm.size),domProps:{"innerHTML":_vm._s(_vm.compileMarkdown(_vm.message))}})
}
var staticRenderFns = []

export { render, staticRenderFns }